/** init domain config */
import Vue from 'vue'
//设置全局API_BASE_URL
Vue.prototype.API_BASE_URL = "https://www.5ggyzl.com/hqptApi"
window._CONFIG['domianURL'] = Vue.prototype.API_BASE_URL
//跳转后台地址地址
window._CONFIG['casPrefixUrl'] = "https://www.5ggyzl.com/hqpt/"
window._CONFIG['onlinePreviewDomainURL'] =  process.env.VUE_APP_ONLINE_BASE_URL
window._CONFIG['staticDomainURL'] = Vue.prototype.API_BASE_URL + '/sys/common/static'
window._CONFIG['pdfDomainURL'] = Vue.prototype.API_BASE_URL+ '/sys/common/pdf/pdfPreviewIframe'

